import Switch from '@material-ui/core/Switch';
import React, { Component }  from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import useStyles from "./FormStyle"
import { withStyles } from '@material-ui/core/styles';


class ActivityStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_active: this.props.userStatus,
            lable: ''
        }
    }
    async componentWillMount()  {
        console.log(this.state.is_active)
        if (this.state.is_active) {
            this.setState({lable : "פעיל"});
        } else {
            this.setState({lable : "לא פעיל"});
        }
    }
    handleChange = () => {
        if(this.state.is_active) {
            this.setState({lable : "לא פעיל"});
            this.state.is_active = false;
            console.log(this.state)
        } else {
            this.setState({lable : "פעיל"});
            this.state.is_active = true;
            console.log(this.state)

        }
    }
    
    render(){
        const {classes} = this.props;

        return(
            <React.Fragment>
                 <div className={classes.purple_text}>
                        סטטוס פעילות
                </div>
                <p className={classes.input_text} ><Switch name="activity_status"
                        defaultChecked={this.state.is_active}
                        onChange={this.handleChange}
                        color="primary"
                        inputProps={{ 'aria-label': 'primary checkbox' }}/> משתמש {this.state.lable}  
                    </p>
                <div className={classes.input_text} textAlign={"right"}>
                    במקרה של "חשבון לא פעיל" לא תהיה כל פעילות בחשבון או יצירת קשר
                </div> 
                <br/>
            </React.Fragment>
            );
    }
}
export default  withStyles(useStyles)(ActivityStatus)